export const SupplierData = [
   {
    id: 3,
    SupplierName: "Fournisseur 1",
    SupplierType: "SARL",
    TaxNumber: "15064KM/000",
    Fax: "",
    Email: "contact@hotel.com",
    Phone: "+21671465222",
    Adresse: "Les berges du ",
    PostalCode : "1002",
    Town : "Tunis",
    Country: "Tunisie",
    Credit : -2000,
    Active : true,
  },
  {
    id: 4,
    SupplierName: "Fournisseur 2",
    SupplierType: "Sans statut",
    TaxNumber: "",
    Fax: "",
    Email: "amine@pp.com",
    Phone: "+21622955555",
    Adresse: "Km 2 rue Mahdia ",
    PostalCode : "7000",
    Town : "Sfax",
    Country: "Tunisie",
Credit : 1200,
    Active : true,

  },
  {
    id: 1,
    SupplierName: "Fournisseur 3",
    SupplierType: "SUARL",
    TaxNumber: "15064KM/000",
    Fax: "",
    Email: "contact@ebs.com",
    Phone: "+21673465222",
    Adresse: "Imm. les jardins",
    PostalCode : "5000",
    Town : "Monastir",
    Country: "Tunisie",
    Credit : 400,
    Active : true,
  },
  {
    id: 2,
    SupplierName: "Société XX",
    SupplierType: "SARL",
    TaxNumber: "15064KM/000",
    Fax: "",
    Email: "contact@xx.com",
    Phone: "+21673986332",
    Adresse: "Imm. xxxx",
    PostalCode : "4000",
    Town : "Sousse",
    Country: "Tunisie",
    Credit : 15000,
    Active : true,
  },
 
  
  {
    id: 5,
    SupplierName: "Idriss d",
    SupplierType: "Personne phisique",
    TaxNumber: "xxxxxxxxxxx",
    Fax: "",
    Email: "Idriss@pp.com",
    Phone: "+21641252698",
    Adresse: "El Menzah 5",
    PostalCode : "1000",
    Town : "Tunis",
    Country: "Tunisie",
    Credit : 0,
    Active : false,

  }
];
